import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  BOARD_MEMBER_CATEGORY,
  BOARD_MEMBER_NAME,
  BOARD_MEMBER_PROFESSION,
  CONTACT_EMAIL,
  CONTACT_NAME,
} from 'constants/formFields';
import { DEFAULT_OPTION, OPTION_CATEGORY_BOARD, OPTION_PROFESSION_BOARD } from 'constants/general';
import getValueOption from 'utils/getOptionValue';
import { boardCreateSchema } from 'utils/validators';

import type { TBoardCreateSchema } from 'utils/validators';
import type ICreateBoardForm from '../interfaces/ICreateBoardForm';

const useCreateBoardForm = ({ isPageLoading, selectedItem }: ICreateBoardForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TBoardCreateSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(boardCreateSchema),
    defaultValues: {
      [BOARD_MEMBER_NAME]: '',
      [BOARD_MEMBER_PROFESSION]: DEFAULT_OPTION,
      [BOARD_MEMBER_CATEGORY]: DEFAULT_OPTION,
      [CONTACT_EMAIL]: '',
      [CONTACT_NAME]: '',
    },
  });

  useEffect(() => {
    if (selectedItem) {
      setValue(BOARD_MEMBER_NAME, selectedItem.name);
      setValue(BOARD_MEMBER_PROFESSION, getValueOption(OPTION_PROFESSION_BOARD, selectedItem.boardMemberProfession));
      setValue(BOARD_MEMBER_CATEGORY, getValueOption(OPTION_CATEGORY_BOARD, selectedItem.boardMemberCategory));
      setValue(CONTACT_EMAIL, selectedItem.contactEmail);
      setValue(CONTACT_NAME, selectedItem.contactName);
    }
  }, [selectedItem, setValue]);

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    resetField,
  };
};

export default useCreateBoardForm;
